import { useLayout } from '@approvalmax/ui/src/components';

import { useProfilePageData } from './hooks/useProfilePageData';

const ProfilePage = () => {
    useLayout();
    useProfilePageData();

    return null;
};

export default ProfilePage;
